
export class AccountRequestDTO {

    name : string
    optionalDescription? : string
    optionalNumber? : number

    constructor(name : string, optionalDescription? : string, optionalNumber? : number) {
        this.name = name
        this.optionalDescription = optionalDescription
        this.optionalNumber = optionalNumber
    }

}